import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Navigation from "@/components/navigation";
import StarfieldBackground from "@/components/starfield-background";
import GamesSection from "@/components/games-section";
import Footer from "../components/footer";
export default function Games() {
    return (_jsxs("div", { className: "min-h-screen bg-space-dark text-white relative overflow-hidden", children: [_jsx(StarfieldBackground, {}), _jsxs("div", { className: "relative z-10", children: [_jsx(Navigation, {}), _jsx("main", { className: "pt-20", children: _jsx(GamesSection, {}) }), _jsx(Footer, {})] })] }));
}
